import React from 'react';

/**
 * USOKIE Platform Button Component
 * Design: Black (#000), Bone (#fffbf7), Sage (#a1c6a2)
 */

const variants = {
  primary: 'bg-[#fffbf7] text-black hover:bg-[#a1c6a2]',
  secondary: 'border border-[rgba(255,251,247,0.2)] text-[rgba(255,251,247,0.6)] hover:text-[#fffbf7] hover:border-[rgba(255,251,247,0.4)] bg-transparent',
  ghost: 'text-[rgba(255,251,247,0.6)] hover:text-[#fffbf7] bg-transparent',
};

const sizes = {
  sm: 'px-4 py-2 text-[10px]',
  md: 'px-6 py-3 text-xs',
  lg: 'px-8 py-4 text-sm',
};

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  as = 'button',
  href,
  className = '',
  disabled = false,
  ...props
}) => {
  const baseStyles = `
    font-semibold tracking-[0.15em] uppercase transition-colors
    disabled:opacity-30 disabled:cursor-not-allowed
  `.trim();

  const variantStyles = variants[variant] || variants.primary;
  const sizeStyles = sizes[size] || sizes.md;

  const combinedClassName = `${baseStyles} ${variantStyles} ${sizeStyles} ${className}`.trim();

  const style = { fontFamily: "'GT Pressura Mono', monospace" };

  if (as === 'a' || href) {
    return (
      <a
        href={href}
        className={combinedClassName}
        style={style}
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      className={combinedClassName}
      style={style}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
